export const exportHtml = `<!DOCTYPE html><html><head><style>
.rjsf {
  font-family: Arial;
  font-size: 12px;
  margin-top: 40px;
}

.rjsf .form-group {
  display: block;
  margin: 0;
}

.rjsf .control-label {
  color: #888;
  font-size: 12px;
  margin: 0 0 2px 0;
}

.rjsf .control-label .required {
  display: none;
}

.rjsf .field-wrapper {
  margin: 0 0 5px 0;
}

.rjsf .field-caption {
  color: #aeb9ce;
  font-size: 11px;
  font-style: italic;
  margin: 2px 0 0 0;
}

.rjsf button {
  display: none;
}

.rjsf .valuestyle,
.rjsf .textareavaluestyle {
  height: 100% !important;
  margin: 0;
  padding: 0;
}

.rjsf .rjsf-addition-field-widget,
.rjsf .rjsf-arithmetic-average-field-widget,
.rjsf .rjsf-arithmetic-expression-field-widget,
.rjsf .rjsf-division-field-widget,
.rjsf .rjsf-minimum-field-widget,
.rjsf .rjsf-maximum-field-widget,
.rjsf .rjsf-multiplication-field-widget,
.rjsf .rjsf-subtraction-field-widget,
.rjsf .rjsf-additional-field-widget,
.rjsf .rjsf-sum-field-widget,
.rjsf .rjsf-online-dictionary-field-widget,
.rjsf .rjsf-contact-field-widget .valuestyle,
.rjsf .rjsf-orgunits-field-widget .valuestyle,
.rjsf .rjsf-user-field-widget .valuestyle,
.rjsf .rjsf-date-field-widget,
.rjsf .rjsf-date-time-field-widget,
.rjsf .rjsf-time-field-widget,
.rjsf .rjsf-external-organization-field-widget,
.rjsf .rjsf-external-user-field-widget,
.rjsf .rjsf-file-chooser-field-widget,
.rjsf .field-wrapper .valuestyle {
  background-color: #f1f1f1;
  border: 1px solid #d0dbe8;
  border-radius: 4px;
  color: #3a3a3a;
  font-family: Arial;
  font-size: 12px;
  min-height: 22px;
  padding: 5px;
  min-width: 150px;
  line-height: 22px;
}

.rjsf .rjsf-custom-widget.rjsf-file-chooser-field-widget {
  padding: 0;
}

.rjsf .rjsf-custom-widget.rjsf-file-chooser-field-widget .valuestyle {
  border: none;
}

.rjsf .field-wrapper .textareavaluestyle {
  background-color: #f1f1f1;
  border: 1px solid #d0dbe8;
  border-radius: 4px;
  color: #3a3a3a;
  font-family: Arial;
  font-size: 15px;
  min-height: 100px;
  max-height: 100%;
  padding: 5px;
  width: 98%;
}

.rjsf .form-group {
  display: flex;
  flex-direction: column;
  margin: 5px 0 10px 0;
}

.rjsf .form-group .field-wrapper {
  display: flex;
  flex-direction: column;
}

.rjsf .field-number-wrapper .field-internal-wrapper {
    align-items: center;
    display: flex;
    flex-direction: row;
}

.rjsf .field-number-wrapper .field-internal-wrapper .field-number-suffix {
    margin-left: 15px;
}

.rjsf .field-object-wrapper.field-object-horizontal-wrapper>fieldset>.field {
  display: inline-block;
  margin: 5px 2px 0 2px;
  padding-right: 15px;
  vertical-align: top;
}

.rjsf .field-object-wrapper>fieldset>.field:only-of-type {
  width: 100%;
}

.rjsf .form-group .rjsf-custom-widget + .field-caption {
  display: none !important;
}

ul {
  list-style-type: none;
}
</style></head><body>#FORM#</body></html>`;
